/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  queryOptions as queryOptionsBuilder,
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ChatDto,
  ChatDtoPagination,
  ChatMemberDto,
  ChatPostDto,
  ChatPostDtoPagination,
  CreateChat,
  CreateChatPost,
  DeleteChatParams,
  DeletePostParams,
  GetChatByIdParams,
  GetChatMembersParams,
  GetChatPostsParams,
  GetChatsParams,
  GetDirectChatIdParams,
  GetDirectChatIdResponse,
  GetFeedPostParams,
  GetFeedPostsForUserParams,
  GetFeedPostsParams,
  GetLastReadPostIdParams,
  GetPageIndexParams,
  GetPageIndexResult,
  GetUnreadPageIndexParams,
  GetUnreadPageIndexResult,
  GetUserIdsByCategoryNodesParams,
  JoinPublicGroupParams,
  LeaveChatParams,
  SearchChatPostsParams,
  SoftDeleteChatMessageParams,
  ToggleInactivateChatParams,
  ToggleMuteChatParams,
  ToggleReactionParams,
  ToggleSubscribeFeedRequest,
  UpdateChat,
  UpdateChatPostParam,
  UpdateReadMessageRequest
} from '../../model';

import { customInstance } from '../../../mutator.ts';
import type { ErrorType , BodyType } from '../../../mutator.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetChatsUrl = (params?: GetChatsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["chatTypeFilters"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Chat/GetChats?${stringifiedParams}` : `/api/Chat/GetChats`
}

export const getChats = async (params?: GetChatsParams, options?: Parameters<typeof customInstance>[1]): Promise<ChatDtoPagination> => {

  return customInstance<ChatDtoPagination>(getGetChatsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetChatsQueryKey = (params?: GetChatsParams,) => {
    return [
    `/api/Chat/GetChats`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetChatsQueryOptions = <TData = Awaited<ReturnType<typeof getChats>>, TError = ErrorType<unknown>>(params?: GetChatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetChatsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getChats>>> = ({ signal }) => getChats(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getChats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetChatsQueryResult = NonNullable<Awaited<ReturnType<typeof getChats>>>
export type GetChatsQueryError = ErrorType<unknown>


export function useGetChats<TData = Awaited<ReturnType<typeof getChats>>, TError = ErrorType<unknown>>(
 params: undefined |  GetChatsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChats>>,
          TError,
          Awaited<ReturnType<typeof getChats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetChats<TData = Awaited<ReturnType<typeof getChats>>, TError = ErrorType<unknown>>(
 params?: GetChatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChats>>,
          TError,
          Awaited<ReturnType<typeof getChats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetChats<TData = Awaited<ReturnType<typeof getChats>>, TError = ErrorType<unknown>>(
 params?: GetChatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetChats<TData = Awaited<ReturnType<typeof getChats>>, TError = ErrorType<unknown>>(
 params?: GetChatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetChatsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetChatsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getChats>>, TError = ErrorType<unknown>>(params?: GetChatsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetChatsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getChats>>> = ({ signal }) => getChats(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetChatsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getChats>>>
export type GetChatsSuspenseQueryError = ErrorType<unknown>


export function useGetChatsSuspense<TData = Awaited<ReturnType<typeof getChats>>, TError = ErrorType<unknown>>(
 params: undefined |  GetChatsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetChatsSuspense<TData = Awaited<ReturnType<typeof getChats>>, TError = ErrorType<unknown>>(
 params?: GetChatsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetChatsSuspense<TData = Awaited<ReturnType<typeof getChats>>, TError = ErrorType<unknown>>(
 params?: GetChatsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetChatsSuspense<TData = Awaited<ReturnType<typeof getChats>>, TError = ErrorType<unknown>>(
 params?: GetChatsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetChatsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreateChatUrl = () => {




  return `/api/Chat/CreateChat`
}

export const createChat = async (createChatBody?: CreateChat, options?: Parameters<typeof customInstance>[1]): Promise<ChatDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<ChatDto>(getCreateChatUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createChatBody)
  }
);}





export const getCreateChatMutationKey = () => ['createChat'] as const;

export const getCreateChatMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createChat>>, TError,CreateChatMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createChat>>, TError,CreateChatMutationVariables, TContext> => {

const mutationKey = getCreateChatMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createChat>>, CreateChatMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createChat(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateChatMutationResult = NonNullable<Awaited<ReturnType<typeof createChat>>>
    export type CreateChatMutationBody = BodyType<CreateChat> | undefined
    export type CreateChatMutationError = ErrorType<unknown>
    export type CreateChatMutationVariables = {data?: BodyType<CreateChat>}

    export const useCreateChat = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createChat>>, TError,CreateChatMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createChat>>,
        TError,
        CreateChatMutationVariables,
        TContext
      > => {
      return useMutation(getCreateChatMutationOptions(options), queryClient);
    }
    export const getGetChatByIdUrl = (params: GetChatByIdParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Chat/GetChatById?${stringifiedParams}` : `/api/Chat/GetChatById`
}

export const getChatById = async (params: GetChatByIdParams, options?: Parameters<typeof customInstance>[1]): Promise<ChatDto> => {

  return customInstance<ChatDto>(getGetChatByIdUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetChatByIdQueryKey = (params?: GetChatByIdParams,) => {
    return [
    `/api/Chat/GetChatById`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetChatByIdQueryOptions = <TData = Awaited<ReturnType<typeof getChatById>>, TError = ErrorType<unknown>>(params: GetChatByIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetChatByIdQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getChatById>>> = ({ signal }) => getChatById(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getChatById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetChatByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getChatById>>>
export type GetChatByIdQueryError = ErrorType<unknown>


export function useGetChatById<TData = Awaited<ReturnType<typeof getChatById>>, TError = ErrorType<unknown>>(
 params: GetChatByIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChatById>>,
          TError,
          Awaited<ReturnType<typeof getChatById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetChatById<TData = Awaited<ReturnType<typeof getChatById>>, TError = ErrorType<unknown>>(
 params: GetChatByIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChatById>>,
          TError,
          Awaited<ReturnType<typeof getChatById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetChatById<TData = Awaited<ReturnType<typeof getChatById>>, TError = ErrorType<unknown>>(
 params: GetChatByIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetChatById<TData = Awaited<ReturnType<typeof getChatById>>, TError = ErrorType<unknown>>(
 params: GetChatByIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetChatByIdQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetChatByIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getChatById>>, TError = ErrorType<unknown>>(params: GetChatByIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChatById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetChatByIdQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getChatById>>> = ({ signal }) => getChatById(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChatById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetChatByIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getChatById>>>
export type GetChatByIdSuspenseQueryError = ErrorType<unknown>


export function useGetChatByIdSuspense<TData = Awaited<ReturnType<typeof getChatById>>, TError = ErrorType<unknown>>(
 params: GetChatByIdParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChatById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetChatByIdSuspense<TData = Awaited<ReturnType<typeof getChatById>>, TError = ErrorType<unknown>>(
 params: GetChatByIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChatById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetChatByIdSuspense<TData = Awaited<ReturnType<typeof getChatById>>, TError = ErrorType<unknown>>(
 params: GetChatByIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChatById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetChatByIdSuspense<TData = Awaited<ReturnType<typeof getChatById>>, TError = ErrorType<unknown>>(
 params: GetChatByIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChatById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetChatByIdSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreateChatPostUrl = () => {




  return `/api/Chat/CreateChatPost`
}

export const createChatPost = async (createChatPostBody?: CreateChatPost, options?: Parameters<typeof customInstance>[1]): Promise<number> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<number>(getCreateChatPostUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createChatPostBody)
  }
);}





export const getCreateChatPostMutationKey = () => ['createChatPost'] as const;

export const getCreateChatPostMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createChatPost>>, TError,CreateChatPostMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createChatPost>>, TError,CreateChatPostMutationVariables, TContext> => {

const mutationKey = getCreateChatPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createChatPost>>, CreateChatPostMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createChatPost(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateChatPostMutationResult = NonNullable<Awaited<ReturnType<typeof createChatPost>>>
    export type CreateChatPostMutationBody = BodyType<CreateChatPost> | undefined
    export type CreateChatPostMutationError = ErrorType<unknown>
    export type CreateChatPostMutationVariables = {data?: BodyType<CreateChatPost>}

    export const useCreateChatPost = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createChatPost>>, TError,CreateChatPostMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createChatPost>>,
        TError,
        CreateChatPostMutationVariables,
        TContext
      > => {
      return useMutation(getCreateChatPostMutationOptions(options), queryClient);
    }
    export const getUpdateMessageContentUrl = () => {




  return `/api/Chat/UpdateMessageContent`
}

export const updateMessageContent = async (updateChatPostParam?: UpdateChatPostParam, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getUpdateMessageContentUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateChatPostParam)
  }
);}





export const getUpdateMessageContentMutationKey = () => ['updateMessageContent'] as const;

export const getUpdateMessageContentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMessageContent>>, TError,UpdateMessageContentMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateMessageContent>>, TError,UpdateMessageContentMutationVariables, TContext> => {

const mutationKey = getUpdateMessageContentMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMessageContent>>, UpdateMessageContentMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateMessageContent(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateMessageContentMutationResult = NonNullable<Awaited<ReturnType<typeof updateMessageContent>>>
    export type UpdateMessageContentMutationBody = BodyType<UpdateChatPostParam> | undefined
    export type UpdateMessageContentMutationError = ErrorType<unknown>
    export type UpdateMessageContentMutationVariables = {data?: BodyType<UpdateChatPostParam>}

    export const useUpdateMessageContent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMessageContent>>, TError,UpdateMessageContentMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateMessageContent>>,
        TError,
        UpdateMessageContentMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateMessageContentMutationOptions(options), queryClient);
    }
    export const getUpdateChatUrl = () => {




  return `/api/Chat/UpdateChat`
}

export const updateChat = async (updateChatBody?: UpdateChat, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getUpdateChatUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateChatBody)
  }
);}





export const getUpdateChatMutationKey = () => ['updateChat'] as const;

export const getUpdateChatMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateChat>>, TError,UpdateChatMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateChat>>, TError,UpdateChatMutationVariables, TContext> => {

const mutationKey = getUpdateChatMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateChat>>, UpdateChatMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateChat(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateChatMutationResult = NonNullable<Awaited<ReturnType<typeof updateChat>>>
    export type UpdateChatMutationBody = BodyType<UpdateChat> | undefined
    export type UpdateChatMutationError = ErrorType<unknown>
    export type UpdateChatMutationVariables = {data?: BodyType<UpdateChat>}

    export const useUpdateChat = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateChat>>, TError,UpdateChatMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateChat>>,
        TError,
        UpdateChatMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateChatMutationOptions(options), queryClient);
    }
    export const getDeleteChatUrl = (params?: DeleteChatParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Chat/DeleteChat?${stringifiedParams}` : `/api/Chat/DeleteChat`
}

export const deleteChat = async (params?: DeleteChatParams, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getDeleteChatUrl(params),
  {
    ...options,
    method: 'POST'


  }
);}





export const getDeleteChatMutationKey = () => ['deleteChat'] as const;

export const getDeleteChatMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteChat>>, TError,DeleteChatMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteChat>>, TError,DeleteChatMutationVariables, TContext> => {

const mutationKey = getDeleteChatMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteChat>>, DeleteChatMutationVariables> = (props) => {
          const {params} = props ?? {};

          return  deleteChat(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteChatMutationResult = NonNullable<Awaited<ReturnType<typeof deleteChat>>>

    export type DeleteChatMutationError = ErrorType<unknown>
    export type DeleteChatMutationVariables = {params?: DeleteChatParams}

    export const useDeleteChat = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteChat>>, TError,DeleteChatMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteChat>>,
        TError,
        DeleteChatMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteChatMutationOptions(options), queryClient);
    }
    export const getGetUnreadCountUrl = () => {




  return `/api/Chat/GetUnreadCount`
}

export const getUnreadCount = async ( options?: Parameters<typeof customInstance>[1]): Promise<number> => {

  return customInstance<number>(getGetUnreadCountUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetUnreadCountQueryKey = () => {
    return [
    `/api/Chat/GetUnreadCount`
    ] as const;
    }


export const getGetUnreadCountQueryOptions = <TData = Awaited<ReturnType<typeof getUnreadCount>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnreadCount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUnreadCountQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUnreadCount>>> = ({ signal }) => getUnreadCount({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUnreadCount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUnreadCountQueryResult = NonNullable<Awaited<ReturnType<typeof getUnreadCount>>>
export type GetUnreadCountQueryError = ErrorType<unknown>


export function useGetUnreadCount<TData = Awaited<ReturnType<typeof getUnreadCount>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnreadCount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUnreadCount>>,
          TError,
          Awaited<ReturnType<typeof getUnreadCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUnreadCount<TData = Awaited<ReturnType<typeof getUnreadCount>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnreadCount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUnreadCount>>,
          TError,
          Awaited<ReturnType<typeof getUnreadCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUnreadCount<TData = Awaited<ReturnType<typeof getUnreadCount>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnreadCount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetUnreadCount<TData = Awaited<ReturnType<typeof getUnreadCount>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnreadCount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUnreadCountQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetUnreadCountSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getUnreadCount>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUnreadCount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUnreadCountQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUnreadCount>>> = ({ signal }) => getUnreadCount({ signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUnreadCount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetUnreadCountSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getUnreadCount>>>
export type GetUnreadCountSuspenseQueryError = ErrorType<unknown>


export function useGetUnreadCountSuspense<TData = Awaited<ReturnType<typeof getUnreadCount>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUnreadCount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUnreadCountSuspense<TData = Awaited<ReturnType<typeof getUnreadCount>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUnreadCount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUnreadCountSuspense<TData = Awaited<ReturnType<typeof getUnreadCount>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUnreadCount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetUnreadCountSuspense<TData = Awaited<ReturnType<typeof getUnreadCount>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUnreadCount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUnreadCountSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetChatPostsUrl = (params?: GetChatPostsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Chat/GetChatPosts?${stringifiedParams}` : `/api/Chat/GetChatPosts`
}

export const getChatPosts = async (params?: GetChatPostsParams, options?: Parameters<typeof customInstance>[1]): Promise<ChatPostDtoPagination> => {

  return customInstance<ChatPostDtoPagination>(getGetChatPostsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetChatPostsQueryKey = (params?: GetChatPostsParams,) => {
    return [
    `/api/Chat/GetChatPosts`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetChatPostsQueryOptions = <TData = Awaited<ReturnType<typeof getChatPosts>>, TError = ErrorType<unknown>>(params?: GetChatPostsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatPosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetChatPostsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getChatPosts>>> = ({ signal }) => getChatPosts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getChatPosts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetChatPostsQueryResult = NonNullable<Awaited<ReturnType<typeof getChatPosts>>>
export type GetChatPostsQueryError = ErrorType<unknown>


export function useGetChatPosts<TData = Awaited<ReturnType<typeof getChatPosts>>, TError = ErrorType<unknown>>(
 params: undefined |  GetChatPostsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatPosts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChatPosts>>,
          TError,
          Awaited<ReturnType<typeof getChatPosts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetChatPosts<TData = Awaited<ReturnType<typeof getChatPosts>>, TError = ErrorType<unknown>>(
 params?: GetChatPostsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatPosts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChatPosts>>,
          TError,
          Awaited<ReturnType<typeof getChatPosts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetChatPosts<TData = Awaited<ReturnType<typeof getChatPosts>>, TError = ErrorType<unknown>>(
 params?: GetChatPostsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatPosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetChatPosts<TData = Awaited<ReturnType<typeof getChatPosts>>, TError = ErrorType<unknown>>(
 params?: GetChatPostsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatPosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetChatPostsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetChatPostsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getChatPosts>>, TError = ErrorType<unknown>>(params?: GetChatPostsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChatPosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetChatPostsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getChatPosts>>> = ({ signal }) => getChatPosts(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChatPosts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetChatPostsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getChatPosts>>>
export type GetChatPostsSuspenseQueryError = ErrorType<unknown>


export function useGetChatPostsSuspense<TData = Awaited<ReturnType<typeof getChatPosts>>, TError = ErrorType<unknown>>(
 params: undefined |  GetChatPostsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChatPosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetChatPostsSuspense<TData = Awaited<ReturnType<typeof getChatPosts>>, TError = ErrorType<unknown>>(
 params?: GetChatPostsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChatPosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetChatPostsSuspense<TData = Awaited<ReturnType<typeof getChatPosts>>, TError = ErrorType<unknown>>(
 params?: GetChatPostsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChatPosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetChatPostsSuspense<TData = Awaited<ReturnType<typeof getChatPosts>>, TError = ErrorType<unknown>>(
 params?: GetChatPostsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChatPosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetChatPostsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getUpdateReadMessageUrl = () => {




  return `/api/Chat/UpdateReadMessage`
}

export const updateReadMessage = async (updateReadMessageRequest?: UpdateReadMessageRequest, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getUpdateReadMessageUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateReadMessageRequest)
  }
);}





export const getUpdateReadMessageMutationKey = () => ['updateReadMessage'] as const;

export const getUpdateReadMessageMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateReadMessage>>, TError,UpdateReadMessageMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateReadMessage>>, TError,UpdateReadMessageMutationVariables, TContext> => {

const mutationKey = getUpdateReadMessageMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateReadMessage>>, UpdateReadMessageMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateReadMessage(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateReadMessageMutationResult = NonNullable<Awaited<ReturnType<typeof updateReadMessage>>>
    export type UpdateReadMessageMutationBody = BodyType<UpdateReadMessageRequest> | undefined
    export type UpdateReadMessageMutationError = ErrorType<unknown>
    export type UpdateReadMessageMutationVariables = {data?: BodyType<UpdateReadMessageRequest>}

    export const useUpdateReadMessage = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateReadMessage>>, TError,UpdateReadMessageMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateReadMessage>>,
        TError,
        UpdateReadMessageMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateReadMessageMutationOptions(options), queryClient);
    }
    export const getJoinPublicGroupUrl = (params: JoinPublicGroupParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Chat/JoinPublicGroup?${stringifiedParams}` : `/api/Chat/JoinPublicGroup`
}

export const joinPublicGroup = async (params: JoinPublicGroupParams, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getJoinPublicGroupUrl(params),
  {
    ...options,
    method: 'POST'


  }
);}





export const getJoinPublicGroupMutationKey = () => ['joinPublicGroup'] as const;

export const getJoinPublicGroupMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof joinPublicGroup>>, TError,JoinPublicGroupMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof joinPublicGroup>>, TError,JoinPublicGroupMutationVariables, TContext> => {

const mutationKey = getJoinPublicGroupMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof joinPublicGroup>>, JoinPublicGroupMutationVariables> = (props) => {
          const {params} = props ?? {};

          return  joinPublicGroup(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type JoinPublicGroupMutationResult = NonNullable<Awaited<ReturnType<typeof joinPublicGroup>>>

    export type JoinPublicGroupMutationError = ErrorType<unknown>
    export type JoinPublicGroupMutationVariables = {params: JoinPublicGroupParams}

    export const useJoinPublicGroup = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof joinPublicGroup>>, TError,JoinPublicGroupMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof joinPublicGroup>>,
        TError,
        JoinPublicGroupMutationVariables,
        TContext
      > => {
      return useMutation(getJoinPublicGroupMutationOptions(options), queryClient);
    }
    export const getToggleMuteChatUrl = (params: ToggleMuteChatParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Chat/ToggleMuteChat?${stringifiedParams}` : `/api/Chat/ToggleMuteChat`
}

export const toggleMuteChat = async (params: ToggleMuteChatParams, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getToggleMuteChatUrl(params),
  {
    ...options,
    method: 'POST'


  }
);}





export const getToggleMuteChatMutationKey = () => ['toggleMuteChat'] as const;

export const getToggleMuteChatMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleMuteChat>>, TError,ToggleMuteChatMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof toggleMuteChat>>, TError,ToggleMuteChatMutationVariables, TContext> => {

const mutationKey = getToggleMuteChatMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof toggleMuteChat>>, ToggleMuteChatMutationVariables> = (props) => {
          const {params} = props ?? {};

          return  toggleMuteChat(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ToggleMuteChatMutationResult = NonNullable<Awaited<ReturnType<typeof toggleMuteChat>>>

    export type ToggleMuteChatMutationError = ErrorType<unknown>
    export type ToggleMuteChatMutationVariables = {params: ToggleMuteChatParams}

    export const useToggleMuteChat = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleMuteChat>>, TError,ToggleMuteChatMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof toggleMuteChat>>,
        TError,
        ToggleMuteChatMutationVariables,
        TContext
      > => {
      return useMutation(getToggleMuteChatMutationOptions(options), queryClient);
    }
    export const getToggleInactivateChatUrl = (params: ToggleInactivateChatParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Chat/ToggleInactivateChat?${stringifiedParams}` : `/api/Chat/ToggleInactivateChat`
}

export const toggleInactivateChat = async (params: ToggleInactivateChatParams, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getToggleInactivateChatUrl(params),
  {
    ...options,
    method: 'POST'


  }
);}





export const getToggleInactivateChatMutationKey = () => ['toggleInactivateChat'] as const;

export const getToggleInactivateChatMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleInactivateChat>>, TError,ToggleInactivateChatMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof toggleInactivateChat>>, TError,ToggleInactivateChatMutationVariables, TContext> => {

const mutationKey = getToggleInactivateChatMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof toggleInactivateChat>>, ToggleInactivateChatMutationVariables> = (props) => {
          const {params} = props ?? {};

          return  toggleInactivateChat(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ToggleInactivateChatMutationResult = NonNullable<Awaited<ReturnType<typeof toggleInactivateChat>>>

    export type ToggleInactivateChatMutationError = ErrorType<unknown>
    export type ToggleInactivateChatMutationVariables = {params: ToggleInactivateChatParams}

    export const useToggleInactivateChat = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleInactivateChat>>, TError,ToggleInactivateChatMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof toggleInactivateChat>>,
        TError,
        ToggleInactivateChatMutationVariables,
        TContext
      > => {
      return useMutation(getToggleInactivateChatMutationOptions(options), queryClient);
    }
    export const getUserHasArchivedChatUrl = () => {




  return `/api/Chat/UserHasArchivedChat`
}

export const userHasArchivedChat = async ( options?: Parameters<typeof customInstance>[1]): Promise<boolean> => {

  return customInstance<boolean>(getUserHasArchivedChatUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getUserHasArchivedChatQueryKey = () => {
    return [
    `/api/Chat/UserHasArchivedChat`
    ] as const;
    }


export const getUserHasArchivedChatQueryOptions = <TData = Awaited<ReturnType<typeof userHasArchivedChat>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userHasArchivedChat>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserHasArchivedChatQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userHasArchivedChat>>> = ({ signal }) => userHasArchivedChat({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userHasArchivedChat>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserHasArchivedChatQueryResult = NonNullable<Awaited<ReturnType<typeof userHasArchivedChat>>>
export type UserHasArchivedChatQueryError = ErrorType<unknown>


export function useUserHasArchivedChat<TData = Awaited<ReturnType<typeof userHasArchivedChat>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userHasArchivedChat>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userHasArchivedChat>>,
          TError,
          Awaited<ReturnType<typeof userHasArchivedChat>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserHasArchivedChat<TData = Awaited<ReturnType<typeof userHasArchivedChat>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userHasArchivedChat>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userHasArchivedChat>>,
          TError,
          Awaited<ReturnType<typeof userHasArchivedChat>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserHasArchivedChat<TData = Awaited<ReturnType<typeof userHasArchivedChat>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userHasArchivedChat>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUserHasArchivedChat<TData = Awaited<ReturnType<typeof userHasArchivedChat>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userHasArchivedChat>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserHasArchivedChatQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getUserHasArchivedChatSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof userHasArchivedChat>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userHasArchivedChat>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserHasArchivedChatQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userHasArchivedChat>>> = ({ signal }) => userHasArchivedChat({ signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof userHasArchivedChat>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type UserHasArchivedChatSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof userHasArchivedChat>>>
export type UserHasArchivedChatSuspenseQueryError = ErrorType<unknown>


export function useUserHasArchivedChatSuspense<TData = Awaited<ReturnType<typeof userHasArchivedChat>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userHasArchivedChat>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserHasArchivedChatSuspense<TData = Awaited<ReturnType<typeof userHasArchivedChat>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userHasArchivedChat>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserHasArchivedChatSuspense<TData = Awaited<ReturnType<typeof userHasArchivedChat>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userHasArchivedChat>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUserHasArchivedChatSuspense<TData = Awaited<ReturnType<typeof userHasArchivedChat>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userHasArchivedChat>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserHasArchivedChatSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetLastReadPostIdUrl = (params?: GetLastReadPostIdParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Chat/GetLastReadPostId?${stringifiedParams}` : `/api/Chat/GetLastReadPostId`
}

export const getLastReadPostId = async (params?: GetLastReadPostIdParams, options?: Parameters<typeof customInstance>[1]): Promise<number | null> => {

  return customInstance<number | null>(getGetLastReadPostIdUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLastReadPostIdQueryKey = (params?: GetLastReadPostIdParams,) => {
    return [
    `/api/Chat/GetLastReadPostId`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLastReadPostIdQueryOptions = <TData = Awaited<ReturnType<typeof getLastReadPostId>>, TError = ErrorType<unknown>>(params?: GetLastReadPostIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLastReadPostId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLastReadPostIdQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLastReadPostId>>> = ({ signal }) => getLastReadPostId(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLastReadPostId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLastReadPostIdQueryResult = NonNullable<Awaited<ReturnType<typeof getLastReadPostId>>>
export type GetLastReadPostIdQueryError = ErrorType<unknown>


export function useGetLastReadPostId<TData = Awaited<ReturnType<typeof getLastReadPostId>>, TError = ErrorType<unknown>>(
 params: undefined |  GetLastReadPostIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLastReadPostId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLastReadPostId>>,
          TError,
          Awaited<ReturnType<typeof getLastReadPostId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLastReadPostId<TData = Awaited<ReturnType<typeof getLastReadPostId>>, TError = ErrorType<unknown>>(
 params?: GetLastReadPostIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLastReadPostId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLastReadPostId>>,
          TError,
          Awaited<ReturnType<typeof getLastReadPostId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLastReadPostId<TData = Awaited<ReturnType<typeof getLastReadPostId>>, TError = ErrorType<unknown>>(
 params?: GetLastReadPostIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLastReadPostId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetLastReadPostId<TData = Awaited<ReturnType<typeof getLastReadPostId>>, TError = ErrorType<unknown>>(
 params?: GetLastReadPostIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLastReadPostId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLastReadPostIdQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetLastReadPostIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getLastReadPostId>>, TError = ErrorType<unknown>>(params?: GetLastReadPostIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLastReadPostId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLastReadPostIdQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLastReadPostId>>> = ({ signal }) => getLastReadPostId(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLastReadPostId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetLastReadPostIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getLastReadPostId>>>
export type GetLastReadPostIdSuspenseQueryError = ErrorType<unknown>


export function useGetLastReadPostIdSuspense<TData = Awaited<ReturnType<typeof getLastReadPostId>>, TError = ErrorType<unknown>>(
 params: undefined |  GetLastReadPostIdParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLastReadPostId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLastReadPostIdSuspense<TData = Awaited<ReturnType<typeof getLastReadPostId>>, TError = ErrorType<unknown>>(
 params?: GetLastReadPostIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLastReadPostId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLastReadPostIdSuspense<TData = Awaited<ReturnType<typeof getLastReadPostId>>, TError = ErrorType<unknown>>(
 params?: GetLastReadPostIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLastReadPostId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetLastReadPostIdSuspense<TData = Awaited<ReturnType<typeof getLastReadPostId>>, TError = ErrorType<unknown>>(
 params?: GetLastReadPostIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getLastReadPostId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLastReadPostIdSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getUserCanCreateChatsUrl = () => {




  return `/api/Chat/UserCanCreateChats`
}

export const userCanCreateChats = async ( options?: Parameters<typeof customInstance>[1]): Promise<boolean> => {

  return customInstance<boolean>(getUserCanCreateChatsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getUserCanCreateChatsQueryKey = () => {
    return [
    `/api/Chat/UserCanCreateChats`
    ] as const;
    }


export const getUserCanCreateChatsQueryOptions = <TData = Awaited<ReturnType<typeof userCanCreateChats>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userCanCreateChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserCanCreateChatsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userCanCreateChats>>> = ({ signal }) => userCanCreateChats({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userCanCreateChats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserCanCreateChatsQueryResult = NonNullable<Awaited<ReturnType<typeof userCanCreateChats>>>
export type UserCanCreateChatsQueryError = ErrorType<unknown>


export function useUserCanCreateChats<TData = Awaited<ReturnType<typeof userCanCreateChats>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userCanCreateChats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userCanCreateChats>>,
          TError,
          Awaited<ReturnType<typeof userCanCreateChats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserCanCreateChats<TData = Awaited<ReturnType<typeof userCanCreateChats>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userCanCreateChats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userCanCreateChats>>,
          TError,
          Awaited<ReturnType<typeof userCanCreateChats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserCanCreateChats<TData = Awaited<ReturnType<typeof userCanCreateChats>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userCanCreateChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUserCanCreateChats<TData = Awaited<ReturnType<typeof userCanCreateChats>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userCanCreateChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserCanCreateChatsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getUserCanCreateChatsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof userCanCreateChats>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userCanCreateChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserCanCreateChatsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userCanCreateChats>>> = ({ signal }) => userCanCreateChats({ signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof userCanCreateChats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type UserCanCreateChatsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof userCanCreateChats>>>
export type UserCanCreateChatsSuspenseQueryError = ErrorType<unknown>


export function useUserCanCreateChatsSuspense<TData = Awaited<ReturnType<typeof userCanCreateChats>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userCanCreateChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserCanCreateChatsSuspense<TData = Awaited<ReturnType<typeof userCanCreateChats>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userCanCreateChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserCanCreateChatsSuspense<TData = Awaited<ReturnType<typeof userCanCreateChats>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userCanCreateChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUserCanCreateChatsSuspense<TData = Awaited<ReturnType<typeof userCanCreateChats>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof userCanCreateChats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserCanCreateChatsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetDirectChatIdUrl = (params?: GetDirectChatIdParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Chat/GetDirectChatId?${stringifiedParams}` : `/api/Chat/GetDirectChatId`
}

export const getDirectChatId = async (params?: GetDirectChatIdParams, options?: Parameters<typeof customInstance>[1]): Promise<GetDirectChatIdResponse> => {

  return customInstance<GetDirectChatIdResponse>(getGetDirectChatIdUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDirectChatIdQueryKey = (params?: GetDirectChatIdParams,) => {
    return [
    `/api/Chat/GetDirectChatId`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDirectChatIdQueryOptions = <TData = Awaited<ReturnType<typeof getDirectChatId>>, TError = ErrorType<unknown>>(params?: GetDirectChatIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDirectChatId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDirectChatIdQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDirectChatId>>> = ({ signal }) => getDirectChatId(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDirectChatId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDirectChatIdQueryResult = NonNullable<Awaited<ReturnType<typeof getDirectChatId>>>
export type GetDirectChatIdQueryError = ErrorType<unknown>


export function useGetDirectChatId<TData = Awaited<ReturnType<typeof getDirectChatId>>, TError = ErrorType<unknown>>(
 params: undefined |  GetDirectChatIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDirectChatId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDirectChatId>>,
          TError,
          Awaited<ReturnType<typeof getDirectChatId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDirectChatId<TData = Awaited<ReturnType<typeof getDirectChatId>>, TError = ErrorType<unknown>>(
 params?: GetDirectChatIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDirectChatId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDirectChatId>>,
          TError,
          Awaited<ReturnType<typeof getDirectChatId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDirectChatId<TData = Awaited<ReturnType<typeof getDirectChatId>>, TError = ErrorType<unknown>>(
 params?: GetDirectChatIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDirectChatId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetDirectChatId<TData = Awaited<ReturnType<typeof getDirectChatId>>, TError = ErrorType<unknown>>(
 params?: GetDirectChatIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDirectChatId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDirectChatIdQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetDirectChatIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getDirectChatId>>, TError = ErrorType<unknown>>(params?: GetDirectChatIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDirectChatId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDirectChatIdQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDirectChatId>>> = ({ signal }) => getDirectChatId(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDirectChatId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetDirectChatIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getDirectChatId>>>
export type GetDirectChatIdSuspenseQueryError = ErrorType<unknown>


export function useGetDirectChatIdSuspense<TData = Awaited<ReturnType<typeof getDirectChatId>>, TError = ErrorType<unknown>>(
 params: undefined |  GetDirectChatIdParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDirectChatId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDirectChatIdSuspense<TData = Awaited<ReturnType<typeof getDirectChatId>>, TError = ErrorType<unknown>>(
 params?: GetDirectChatIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDirectChatId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDirectChatIdSuspense<TData = Awaited<ReturnType<typeof getDirectChatId>>, TError = ErrorType<unknown>>(
 params?: GetDirectChatIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDirectChatId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetDirectChatIdSuspense<TData = Awaited<ReturnType<typeof getDirectChatId>>, TError = ErrorType<unknown>>(
 params?: GetDirectChatIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDirectChatId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDirectChatIdSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getSoftDeleteChatMessageUrl = (params?: SoftDeleteChatMessageParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Chat/SoftDeleteChatMessage?${stringifiedParams}` : `/api/Chat/SoftDeleteChatMessage`
}

export const softDeleteChatMessage = async (params?: SoftDeleteChatMessageParams, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getSoftDeleteChatMessageUrl(params),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSoftDeleteChatMessageMutationKey = () => ['softDeleteChatMessage'] as const;

export const getSoftDeleteChatMessageMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof softDeleteChatMessage>>, TError,SoftDeleteChatMessageMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof softDeleteChatMessage>>, TError,SoftDeleteChatMessageMutationVariables, TContext> => {

const mutationKey = getSoftDeleteChatMessageMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof softDeleteChatMessage>>, SoftDeleteChatMessageMutationVariables> = (props) => {
          const {params} = props ?? {};

          return  softDeleteChatMessage(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SoftDeleteChatMessageMutationResult = NonNullable<Awaited<ReturnType<typeof softDeleteChatMessage>>>

    export type SoftDeleteChatMessageMutationError = ErrorType<unknown>
    export type SoftDeleteChatMessageMutationVariables = {params?: SoftDeleteChatMessageParams}

    export const useSoftDeleteChatMessage = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof softDeleteChatMessage>>, TError,SoftDeleteChatMessageMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof softDeleteChatMessage>>,
        TError,
        SoftDeleteChatMessageMutationVariables,
        TContext
      > => {
      return useMutation(getSoftDeleteChatMessageMutationOptions(options), queryClient);
    }
    export const getGetChatMembersUrl = (params?: GetChatMembersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Chat/GetChatMembers?${stringifiedParams}` : `/api/Chat/GetChatMembers`
}

export const getChatMembers = async (params?: GetChatMembersParams, options?: Parameters<typeof customInstance>[1]): Promise<ChatMemberDto[]> => {

  return customInstance<ChatMemberDto[]>(getGetChatMembersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetChatMembersQueryKey = (params?: GetChatMembersParams,) => {
    return [
    `/api/Chat/GetChatMembers`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetChatMembersQueryOptions = <TData = Awaited<ReturnType<typeof getChatMembers>>, TError = ErrorType<unknown>>(params?: GetChatMembersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatMembers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetChatMembersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getChatMembers>>> = ({ signal }) => getChatMembers(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getChatMembers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetChatMembersQueryResult = NonNullable<Awaited<ReturnType<typeof getChatMembers>>>
export type GetChatMembersQueryError = ErrorType<unknown>


export function useGetChatMembers<TData = Awaited<ReturnType<typeof getChatMembers>>, TError = ErrorType<unknown>>(
 params: undefined |  GetChatMembersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatMembers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChatMembers>>,
          TError,
          Awaited<ReturnType<typeof getChatMembers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetChatMembers<TData = Awaited<ReturnType<typeof getChatMembers>>, TError = ErrorType<unknown>>(
 params?: GetChatMembersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatMembers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChatMembers>>,
          TError,
          Awaited<ReturnType<typeof getChatMembers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetChatMembers<TData = Awaited<ReturnType<typeof getChatMembers>>, TError = ErrorType<unknown>>(
 params?: GetChatMembersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatMembers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetChatMembers<TData = Awaited<ReturnType<typeof getChatMembers>>, TError = ErrorType<unknown>>(
 params?: GetChatMembersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChatMembers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetChatMembersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetChatMembersSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getChatMembers>>, TError = ErrorType<unknown>>(params?: GetChatMembersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChatMembers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetChatMembersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getChatMembers>>> = ({ signal }) => getChatMembers(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChatMembers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetChatMembersSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getChatMembers>>>
export type GetChatMembersSuspenseQueryError = ErrorType<unknown>


export function useGetChatMembersSuspense<TData = Awaited<ReturnType<typeof getChatMembers>>, TError = ErrorType<unknown>>(
 params: undefined |  GetChatMembersParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChatMembers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetChatMembersSuspense<TData = Awaited<ReturnType<typeof getChatMembers>>, TError = ErrorType<unknown>>(
 params?: GetChatMembersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChatMembers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetChatMembersSuspense<TData = Awaited<ReturnType<typeof getChatMembers>>, TError = ErrorType<unknown>>(
 params?: GetChatMembersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChatMembers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetChatMembersSuspense<TData = Awaited<ReturnType<typeof getChatMembers>>, TError = ErrorType<unknown>>(
 params?: GetChatMembersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChatMembers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetChatMembersSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPageIndexUrl = (params?: GetPageIndexParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Chat/GetPageIndex?${stringifiedParams}` : `/api/Chat/GetPageIndex`
}

export const getPageIndex = async (params?: GetPageIndexParams, options?: Parameters<typeof customInstance>[1]): Promise<GetPageIndexResult> => {

  return customInstance<GetPageIndexResult>(getGetPageIndexUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPageIndexQueryKey = (params?: GetPageIndexParams,) => {
    return [
    `/api/Chat/GetPageIndex`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPageIndexQueryOptions = <TData = Awaited<ReturnType<typeof getPageIndex>>, TError = ErrorType<unknown>>(params?: GetPageIndexParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPageIndex>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPageIndexQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPageIndex>>> = ({ signal }) => getPageIndex(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPageIndex>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPageIndexQueryResult = NonNullable<Awaited<ReturnType<typeof getPageIndex>>>
export type GetPageIndexQueryError = ErrorType<unknown>


export function useGetPageIndex<TData = Awaited<ReturnType<typeof getPageIndex>>, TError = ErrorType<unknown>>(
 params: undefined |  GetPageIndexParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPageIndex>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPageIndex>>,
          TError,
          Awaited<ReturnType<typeof getPageIndex>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPageIndex<TData = Awaited<ReturnType<typeof getPageIndex>>, TError = ErrorType<unknown>>(
 params?: GetPageIndexParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPageIndex>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPageIndex>>,
          TError,
          Awaited<ReturnType<typeof getPageIndex>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPageIndex<TData = Awaited<ReturnType<typeof getPageIndex>>, TError = ErrorType<unknown>>(
 params?: GetPageIndexParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPageIndex>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPageIndex<TData = Awaited<ReturnType<typeof getPageIndex>>, TError = ErrorType<unknown>>(
 params?: GetPageIndexParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPageIndex>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPageIndexQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPageIndexSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPageIndex>>, TError = ErrorType<unknown>>(params?: GetPageIndexParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPageIndex>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPageIndexQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPageIndex>>> = ({ signal }) => getPageIndex(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPageIndex>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetPageIndexSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPageIndex>>>
export type GetPageIndexSuspenseQueryError = ErrorType<unknown>


export function useGetPageIndexSuspense<TData = Awaited<ReturnType<typeof getPageIndex>>, TError = ErrorType<unknown>>(
 params: undefined |  GetPageIndexParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPageIndex>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPageIndexSuspense<TData = Awaited<ReturnType<typeof getPageIndex>>, TError = ErrorType<unknown>>(
 params?: GetPageIndexParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPageIndex>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPageIndexSuspense<TData = Awaited<ReturnType<typeof getPageIndex>>, TError = ErrorType<unknown>>(
 params?: GetPageIndexParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPageIndex>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPageIndexSuspense<TData = Awaited<ReturnType<typeof getPageIndex>>, TError = ErrorType<unknown>>(
 params?: GetPageIndexParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPageIndex>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPageIndexSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetUnreadPageIndexUrl = (params?: GetUnreadPageIndexParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Chat/GetUnreadPageIndex?${stringifiedParams}` : `/api/Chat/GetUnreadPageIndex`
}

export const getUnreadPageIndex = async (params?: GetUnreadPageIndexParams, options?: Parameters<typeof customInstance>[1]): Promise<GetUnreadPageIndexResult> => {

  return customInstance<GetUnreadPageIndexResult>(getGetUnreadPageIndexUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetUnreadPageIndexQueryKey = (params?: GetUnreadPageIndexParams,) => {
    return [
    `/api/Chat/GetUnreadPageIndex`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetUnreadPageIndexQueryOptions = <TData = Awaited<ReturnType<typeof getUnreadPageIndex>>, TError = ErrorType<unknown>>(params?: GetUnreadPageIndexParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnreadPageIndex>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUnreadPageIndexQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUnreadPageIndex>>> = ({ signal }) => getUnreadPageIndex(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUnreadPageIndex>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUnreadPageIndexQueryResult = NonNullable<Awaited<ReturnType<typeof getUnreadPageIndex>>>
export type GetUnreadPageIndexQueryError = ErrorType<unknown>


export function useGetUnreadPageIndex<TData = Awaited<ReturnType<typeof getUnreadPageIndex>>, TError = ErrorType<unknown>>(
 params: undefined |  GetUnreadPageIndexParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnreadPageIndex>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUnreadPageIndex>>,
          TError,
          Awaited<ReturnType<typeof getUnreadPageIndex>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUnreadPageIndex<TData = Awaited<ReturnType<typeof getUnreadPageIndex>>, TError = ErrorType<unknown>>(
 params?: GetUnreadPageIndexParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnreadPageIndex>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUnreadPageIndex>>,
          TError,
          Awaited<ReturnType<typeof getUnreadPageIndex>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUnreadPageIndex<TData = Awaited<ReturnType<typeof getUnreadPageIndex>>, TError = ErrorType<unknown>>(
 params?: GetUnreadPageIndexParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnreadPageIndex>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetUnreadPageIndex<TData = Awaited<ReturnType<typeof getUnreadPageIndex>>, TError = ErrorType<unknown>>(
 params?: GetUnreadPageIndexParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnreadPageIndex>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUnreadPageIndexQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetUnreadPageIndexSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getUnreadPageIndex>>, TError = ErrorType<unknown>>(params?: GetUnreadPageIndexParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUnreadPageIndex>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUnreadPageIndexQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUnreadPageIndex>>> = ({ signal }) => getUnreadPageIndex(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUnreadPageIndex>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetUnreadPageIndexSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getUnreadPageIndex>>>
export type GetUnreadPageIndexSuspenseQueryError = ErrorType<unknown>


export function useGetUnreadPageIndexSuspense<TData = Awaited<ReturnType<typeof getUnreadPageIndex>>, TError = ErrorType<unknown>>(
 params: undefined |  GetUnreadPageIndexParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUnreadPageIndex>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUnreadPageIndexSuspense<TData = Awaited<ReturnType<typeof getUnreadPageIndex>>, TError = ErrorType<unknown>>(
 params?: GetUnreadPageIndexParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUnreadPageIndex>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUnreadPageIndexSuspense<TData = Awaited<ReturnType<typeof getUnreadPageIndex>>, TError = ErrorType<unknown>>(
 params?: GetUnreadPageIndexParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUnreadPageIndex>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetUnreadPageIndexSuspense<TData = Awaited<ReturnType<typeof getUnreadPageIndex>>, TError = ErrorType<unknown>>(
 params?: GetUnreadPageIndexParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUnreadPageIndex>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUnreadPageIndexSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getSearchChatPostsUrl = (params?: SearchChatPostsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Chat/SearchChatPosts?${stringifiedParams}` : `/api/Chat/SearchChatPosts`
}

export const searchChatPosts = async (params?: SearchChatPostsParams, options?: Parameters<typeof customInstance>[1]): Promise<number[]> => {

  return customInstance<number[]>(getSearchChatPostsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSearchChatPostsQueryKey = (params?: SearchChatPostsParams,) => {
    return [
    `/api/Chat/SearchChatPosts`, ...(params ? [params] : [])
    ] as const;
    }


export const getSearchChatPostsQueryOptions = <TData = Awaited<ReturnType<typeof searchChatPosts>>, TError = ErrorType<unknown>>(params?: SearchChatPostsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchChatPosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchChatPostsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchChatPosts>>> = ({ signal }) => searchChatPosts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchChatPosts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SearchChatPostsQueryResult = NonNullable<Awaited<ReturnType<typeof searchChatPosts>>>
export type SearchChatPostsQueryError = ErrorType<unknown>


export function useSearchChatPosts<TData = Awaited<ReturnType<typeof searchChatPosts>>, TError = ErrorType<unknown>>(
 params: undefined |  SearchChatPostsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchChatPosts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchChatPosts>>,
          TError,
          Awaited<ReturnType<typeof searchChatPosts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchChatPosts<TData = Awaited<ReturnType<typeof searchChatPosts>>, TError = ErrorType<unknown>>(
 params?: SearchChatPostsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchChatPosts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchChatPosts>>,
          TError,
          Awaited<ReturnType<typeof searchChatPosts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchChatPosts<TData = Awaited<ReturnType<typeof searchChatPosts>>, TError = ErrorType<unknown>>(
 params?: SearchChatPostsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchChatPosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSearchChatPosts<TData = Awaited<ReturnType<typeof searchChatPosts>>, TError = ErrorType<unknown>>(
 params?: SearchChatPostsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchChatPosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchChatPostsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getSearchChatPostsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof searchChatPosts>>, TError = ErrorType<unknown>>(params?: SearchChatPostsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof searchChatPosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchChatPostsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchChatPosts>>> = ({ signal }) => searchChatPosts(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof searchChatPosts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type SearchChatPostsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof searchChatPosts>>>
export type SearchChatPostsSuspenseQueryError = ErrorType<unknown>


export function useSearchChatPostsSuspense<TData = Awaited<ReturnType<typeof searchChatPosts>>, TError = ErrorType<unknown>>(
 params: undefined |  SearchChatPostsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof searchChatPosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchChatPostsSuspense<TData = Awaited<ReturnType<typeof searchChatPosts>>, TError = ErrorType<unknown>>(
 params?: SearchChatPostsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof searchChatPosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchChatPostsSuspense<TData = Awaited<ReturnType<typeof searchChatPosts>>, TError = ErrorType<unknown>>(
 params?: SearchChatPostsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof searchChatPosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSearchChatPostsSuspense<TData = Awaited<ReturnType<typeof searchChatPosts>>, TError = ErrorType<unknown>>(
 params?: SearchChatPostsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof searchChatPosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchChatPostsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetFeedPostsUrl = (params?: GetFeedPostsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Chat/GetFeedPosts?${stringifiedParams}` : `/api/Chat/GetFeedPosts`
}

export const getFeedPosts = async (params?: GetFeedPostsParams, options?: Parameters<typeof customInstance>[1]): Promise<ChatPostDtoPagination> => {

  return customInstance<ChatPostDtoPagination>(getGetFeedPostsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetFeedPostsQueryKey = (params?: GetFeedPostsParams,) => {
    return [
    `/api/Chat/GetFeedPosts`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetFeedPostsQueryOptions = <TData = Awaited<ReturnType<typeof getFeedPosts>>, TError = ErrorType<unknown>>(params?: GetFeedPostsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeedPosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFeedPostsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFeedPosts>>> = ({ signal }) => getFeedPosts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFeedPosts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFeedPostsQueryResult = NonNullable<Awaited<ReturnType<typeof getFeedPosts>>>
export type GetFeedPostsQueryError = ErrorType<unknown>


export function useGetFeedPosts<TData = Awaited<ReturnType<typeof getFeedPosts>>, TError = ErrorType<unknown>>(
 params: undefined |  GetFeedPostsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeedPosts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeedPosts>>,
          TError,
          Awaited<ReturnType<typeof getFeedPosts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFeedPosts<TData = Awaited<ReturnType<typeof getFeedPosts>>, TError = ErrorType<unknown>>(
 params?: GetFeedPostsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeedPosts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeedPosts>>,
          TError,
          Awaited<ReturnType<typeof getFeedPosts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFeedPosts<TData = Awaited<ReturnType<typeof getFeedPosts>>, TError = ErrorType<unknown>>(
 params?: GetFeedPostsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeedPosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetFeedPosts<TData = Awaited<ReturnType<typeof getFeedPosts>>, TError = ErrorType<unknown>>(
 params?: GetFeedPostsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeedPosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFeedPostsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetFeedPostsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getFeedPosts>>, TError = ErrorType<unknown>>(params?: GetFeedPostsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFeedPosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFeedPostsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFeedPosts>>> = ({ signal }) => getFeedPosts(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFeedPosts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetFeedPostsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getFeedPosts>>>
export type GetFeedPostsSuspenseQueryError = ErrorType<unknown>


export function useGetFeedPostsSuspense<TData = Awaited<ReturnType<typeof getFeedPosts>>, TError = ErrorType<unknown>>(
 params: undefined |  GetFeedPostsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFeedPosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFeedPostsSuspense<TData = Awaited<ReturnType<typeof getFeedPosts>>, TError = ErrorType<unknown>>(
 params?: GetFeedPostsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFeedPosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFeedPostsSuspense<TData = Awaited<ReturnType<typeof getFeedPosts>>, TError = ErrorType<unknown>>(
 params?: GetFeedPostsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFeedPosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetFeedPostsSuspense<TData = Awaited<ReturnType<typeof getFeedPosts>>, TError = ErrorType<unknown>>(
 params?: GetFeedPostsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFeedPosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFeedPostsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetFeedPostsForUserUrl = (params: GetFeedPostsForUserParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Chat/GetFeedPostsForUser?${stringifiedParams}` : `/api/Chat/GetFeedPostsForUser`
}

export const getFeedPostsForUser = async (params: GetFeedPostsForUserParams, options?: Parameters<typeof customInstance>[1]): Promise<ChatPostDtoPagination> => {

  return customInstance<ChatPostDtoPagination>(getGetFeedPostsForUserUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetFeedPostsForUserQueryKey = (params?: GetFeedPostsForUserParams,) => {
    return [
    `/api/Chat/GetFeedPostsForUser`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetFeedPostsForUserQueryOptions = <TData = Awaited<ReturnType<typeof getFeedPostsForUser>>, TError = ErrorType<unknown>>(params: GetFeedPostsForUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeedPostsForUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFeedPostsForUserQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFeedPostsForUser>>> = ({ signal }) => getFeedPostsForUser(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFeedPostsForUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFeedPostsForUserQueryResult = NonNullable<Awaited<ReturnType<typeof getFeedPostsForUser>>>
export type GetFeedPostsForUserQueryError = ErrorType<unknown>


export function useGetFeedPostsForUser<TData = Awaited<ReturnType<typeof getFeedPostsForUser>>, TError = ErrorType<unknown>>(
 params: GetFeedPostsForUserParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeedPostsForUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeedPostsForUser>>,
          TError,
          Awaited<ReturnType<typeof getFeedPostsForUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFeedPostsForUser<TData = Awaited<ReturnType<typeof getFeedPostsForUser>>, TError = ErrorType<unknown>>(
 params: GetFeedPostsForUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeedPostsForUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeedPostsForUser>>,
          TError,
          Awaited<ReturnType<typeof getFeedPostsForUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFeedPostsForUser<TData = Awaited<ReturnType<typeof getFeedPostsForUser>>, TError = ErrorType<unknown>>(
 params: GetFeedPostsForUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeedPostsForUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetFeedPostsForUser<TData = Awaited<ReturnType<typeof getFeedPostsForUser>>, TError = ErrorType<unknown>>(
 params: GetFeedPostsForUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeedPostsForUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFeedPostsForUserQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetFeedPostsForUserSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getFeedPostsForUser>>, TError = ErrorType<unknown>>(params: GetFeedPostsForUserParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFeedPostsForUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFeedPostsForUserQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFeedPostsForUser>>> = ({ signal }) => getFeedPostsForUser(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFeedPostsForUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetFeedPostsForUserSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getFeedPostsForUser>>>
export type GetFeedPostsForUserSuspenseQueryError = ErrorType<unknown>


export function useGetFeedPostsForUserSuspense<TData = Awaited<ReturnType<typeof getFeedPostsForUser>>, TError = ErrorType<unknown>>(
 params: GetFeedPostsForUserParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFeedPostsForUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFeedPostsForUserSuspense<TData = Awaited<ReturnType<typeof getFeedPostsForUser>>, TError = ErrorType<unknown>>(
 params: GetFeedPostsForUserParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFeedPostsForUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFeedPostsForUserSuspense<TData = Awaited<ReturnType<typeof getFeedPostsForUser>>, TError = ErrorType<unknown>>(
 params: GetFeedPostsForUserParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFeedPostsForUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetFeedPostsForUserSuspense<TData = Awaited<ReturnType<typeof getFeedPostsForUser>>, TError = ErrorType<unknown>>(
 params: GetFeedPostsForUserParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFeedPostsForUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFeedPostsForUserSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetFeedPostUrl = (params?: GetFeedPostParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Chat/GetFeedPost?${stringifiedParams}` : `/api/Chat/GetFeedPost`
}

export const getFeedPost = async (params?: GetFeedPostParams, options?: Parameters<typeof customInstance>[1]): Promise<ChatPostDto> => {

  return customInstance<ChatPostDto>(getGetFeedPostUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetFeedPostQueryKey = (params?: GetFeedPostParams,) => {
    return [
    `/api/Chat/GetFeedPost`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetFeedPostQueryOptions = <TData = Awaited<ReturnType<typeof getFeedPost>>, TError = ErrorType<unknown>>(params?: GetFeedPostParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeedPost>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFeedPostQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFeedPost>>> = ({ signal }) => getFeedPost(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFeedPost>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFeedPostQueryResult = NonNullable<Awaited<ReturnType<typeof getFeedPost>>>
export type GetFeedPostQueryError = ErrorType<unknown>


export function useGetFeedPost<TData = Awaited<ReturnType<typeof getFeedPost>>, TError = ErrorType<unknown>>(
 params: undefined |  GetFeedPostParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeedPost>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeedPost>>,
          TError,
          Awaited<ReturnType<typeof getFeedPost>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFeedPost<TData = Awaited<ReturnType<typeof getFeedPost>>, TError = ErrorType<unknown>>(
 params?: GetFeedPostParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeedPost>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeedPost>>,
          TError,
          Awaited<ReturnType<typeof getFeedPost>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFeedPost<TData = Awaited<ReturnType<typeof getFeedPost>>, TError = ErrorType<unknown>>(
 params?: GetFeedPostParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeedPost>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetFeedPost<TData = Awaited<ReturnType<typeof getFeedPost>>, TError = ErrorType<unknown>>(
 params?: GetFeedPostParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeedPost>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFeedPostQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetFeedPostSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getFeedPost>>, TError = ErrorType<unknown>>(params?: GetFeedPostParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFeedPost>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFeedPostQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFeedPost>>> = ({ signal }) => getFeedPost(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFeedPost>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetFeedPostSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getFeedPost>>>
export type GetFeedPostSuspenseQueryError = ErrorType<unknown>


export function useGetFeedPostSuspense<TData = Awaited<ReturnType<typeof getFeedPost>>, TError = ErrorType<unknown>>(
 params: undefined |  GetFeedPostParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFeedPost>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFeedPostSuspense<TData = Awaited<ReturnType<typeof getFeedPost>>, TError = ErrorType<unknown>>(
 params?: GetFeedPostParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFeedPost>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFeedPostSuspense<TData = Awaited<ReturnType<typeof getFeedPost>>, TError = ErrorType<unknown>>(
 params?: GetFeedPostParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFeedPost>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetFeedPostSuspense<TData = Awaited<ReturnType<typeof getFeedPost>>, TError = ErrorType<unknown>>(
 params?: GetFeedPostParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFeedPost>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFeedPostSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getDeletePostUrl = (params?: DeletePostParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Chat/DeletePost?${stringifiedParams}` : `/api/Chat/DeletePost`
}

export const deletePost = async (params?: DeletePostParams, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getDeletePostUrl(params),
  {
    ...options,
    method: 'POST'


  }
);}





export const getDeletePostMutationKey = () => ['deletePost'] as const;

export const getDeletePostMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePost>>, TError,DeletePostMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePost>>, TError,DeletePostMutationVariables, TContext> => {

const mutationKey = getDeletePostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePost>>, DeletePostMutationVariables> = (props) => {
          const {params} = props ?? {};

          return  deletePost(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePostMutationResult = NonNullable<Awaited<ReturnType<typeof deletePost>>>

    export type DeletePostMutationError = ErrorType<unknown>
    export type DeletePostMutationVariables = {params?: DeletePostParams}

    export const useDeletePost = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePost>>, TError,DeletePostMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePost>>,
        TError,
        DeletePostMutationVariables,
        TContext
      > => {
      return useMutation(getDeletePostMutationOptions(options), queryClient);
    }
    export const getToggleReactionUrl = (params?: ToggleReactionParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Chat/ToggleReaction?${stringifiedParams}` : `/api/Chat/ToggleReaction`
}

export const toggleReaction = async (params?: ToggleReactionParams, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getToggleReactionUrl(params),
  {
    ...options,
    method: 'POST'


  }
);}





export const getToggleReactionMutationKey = () => ['toggleReaction'] as const;

export const getToggleReactionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleReaction>>, TError,ToggleReactionMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof toggleReaction>>, TError,ToggleReactionMutationVariables, TContext> => {

const mutationKey = getToggleReactionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof toggleReaction>>, ToggleReactionMutationVariables> = (props) => {
          const {params} = props ?? {};

          return  toggleReaction(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ToggleReactionMutationResult = NonNullable<Awaited<ReturnType<typeof toggleReaction>>>

    export type ToggleReactionMutationError = ErrorType<unknown>
    export type ToggleReactionMutationVariables = {params?: ToggleReactionParams}

    export const useToggleReaction = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleReaction>>, TError,ToggleReactionMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof toggleReaction>>,
        TError,
        ToggleReactionMutationVariables,
        TContext
      > => {
      return useMutation(getToggleReactionMutationOptions(options), queryClient);
    }
    export const getToggleSubscribeFeedUrl = () => {




  return `/api/Chat/ToggleSubscribeFeed`
}

export const toggleSubscribeFeed = async (toggleSubscribeFeedRequest?: ToggleSubscribeFeedRequest, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getToggleSubscribeFeedUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(toggleSubscribeFeedRequest)
  }
);}





export const getToggleSubscribeFeedMutationKey = () => ['toggleSubscribeFeed'] as const;

export const getToggleSubscribeFeedMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleSubscribeFeed>>, TError,ToggleSubscribeFeedMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof toggleSubscribeFeed>>, TError,ToggleSubscribeFeedMutationVariables, TContext> => {

const mutationKey = getToggleSubscribeFeedMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof toggleSubscribeFeed>>, ToggleSubscribeFeedMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  toggleSubscribeFeed(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ToggleSubscribeFeedMutationResult = NonNullable<Awaited<ReturnType<typeof toggleSubscribeFeed>>>
    export type ToggleSubscribeFeedMutationBody = BodyType<ToggleSubscribeFeedRequest> | undefined
    export type ToggleSubscribeFeedMutationError = ErrorType<unknown>
    export type ToggleSubscribeFeedMutationVariables = {data?: BodyType<ToggleSubscribeFeedRequest>}

    export const useToggleSubscribeFeed = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleSubscribeFeed>>, TError,ToggleSubscribeFeedMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof toggleSubscribeFeed>>,
        TError,
        ToggleSubscribeFeedMutationVariables,
        TContext
      > => {
      return useMutation(getToggleSubscribeFeedMutationOptions(options), queryClient);
    }
    export const getGetUserIdsByCategoryNodesUrl = (params?: GetUserIdsByCategoryNodesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["treeNodes"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }


  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Chat/GetUserIdsByCategoryNodes?${stringifiedParams}` : `/api/Chat/GetUserIdsByCategoryNodes`
}

export const getUserIdsByCategoryNodes = async (params?: GetUserIdsByCategoryNodesParams, options?: Parameters<typeof customInstance>[1]): Promise<number[]> => {

  return customInstance<number[]>(getGetUserIdsByCategoryNodesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetUserIdsByCategoryNodesQueryKey = (params?: GetUserIdsByCategoryNodesParams,) => {
    return [
    `/api/Chat/GetUserIdsByCategoryNodes`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetUserIdsByCategoryNodesQueryOptions = <TData = Awaited<ReturnType<typeof getUserIdsByCategoryNodes>>, TError = ErrorType<unknown>>(params?: GetUserIdsByCategoryNodesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIdsByCategoryNodes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserIdsByCategoryNodesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserIdsByCategoryNodes>>> = ({ signal }) => getUserIdsByCategoryNodes(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserIdsByCategoryNodes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserIdsByCategoryNodesQueryResult = NonNullable<Awaited<ReturnType<typeof getUserIdsByCategoryNodes>>>
export type GetUserIdsByCategoryNodesQueryError = ErrorType<unknown>


export function useGetUserIdsByCategoryNodes<TData = Awaited<ReturnType<typeof getUserIdsByCategoryNodes>>, TError = ErrorType<unknown>>(
 params: undefined |  GetUserIdsByCategoryNodesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIdsByCategoryNodes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserIdsByCategoryNodes>>,
          TError,
          Awaited<ReturnType<typeof getUserIdsByCategoryNodes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserIdsByCategoryNodes<TData = Awaited<ReturnType<typeof getUserIdsByCategoryNodes>>, TError = ErrorType<unknown>>(
 params?: GetUserIdsByCategoryNodesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIdsByCategoryNodes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserIdsByCategoryNodes>>,
          TError,
          Awaited<ReturnType<typeof getUserIdsByCategoryNodes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserIdsByCategoryNodes<TData = Awaited<ReturnType<typeof getUserIdsByCategoryNodes>>, TError = ErrorType<unknown>>(
 params?: GetUserIdsByCategoryNodesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIdsByCategoryNodes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetUserIdsByCategoryNodes<TData = Awaited<ReturnType<typeof getUserIdsByCategoryNodes>>, TError = ErrorType<unknown>>(
 params?: GetUserIdsByCategoryNodesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIdsByCategoryNodes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserIdsByCategoryNodesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetUserIdsByCategoryNodesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getUserIdsByCategoryNodes>>, TError = ErrorType<unknown>>(params?: GetUserIdsByCategoryNodesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserIdsByCategoryNodes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserIdsByCategoryNodesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserIdsByCategoryNodes>>> = ({ signal }) => getUserIdsByCategoryNodes(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserIdsByCategoryNodes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetUserIdsByCategoryNodesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getUserIdsByCategoryNodes>>>
export type GetUserIdsByCategoryNodesSuspenseQueryError = ErrorType<unknown>


export function useGetUserIdsByCategoryNodesSuspense<TData = Awaited<ReturnType<typeof getUserIdsByCategoryNodes>>, TError = ErrorType<unknown>>(
 params: undefined |  GetUserIdsByCategoryNodesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserIdsByCategoryNodes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserIdsByCategoryNodesSuspense<TData = Awaited<ReturnType<typeof getUserIdsByCategoryNodes>>, TError = ErrorType<unknown>>(
 params?: GetUserIdsByCategoryNodesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserIdsByCategoryNodes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserIdsByCategoryNodesSuspense<TData = Awaited<ReturnType<typeof getUserIdsByCategoryNodes>>, TError = ErrorType<unknown>>(
 params?: GetUserIdsByCategoryNodesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserIdsByCategoryNodes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetUserIdsByCategoryNodesSuspense<TData = Awaited<ReturnType<typeof getUserIdsByCategoryNodes>>, TError = ErrorType<unknown>>(
 params?: GetUserIdsByCategoryNodesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserIdsByCategoryNodes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserIdsByCategoryNodesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getLeaveChatUrl = (params: LeaveChatParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Chat/LeaveChat?${stringifiedParams}` : `/api/Chat/LeaveChat`
}

export const leaveChat = async (params: LeaveChatParams, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getLeaveChatUrl(params),
  {
    ...options,
    method: 'POST'


  }
);}





export const getLeaveChatMutationKey = () => ['leaveChat'] as const;

export const getLeaveChatMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof leaveChat>>, TError,LeaveChatMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof leaveChat>>, TError,LeaveChatMutationVariables, TContext> => {

const mutationKey = getLeaveChatMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof leaveChat>>, LeaveChatMutationVariables> = (props) => {
          const {params} = props ?? {};

          return  leaveChat(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LeaveChatMutationResult = NonNullable<Awaited<ReturnType<typeof leaveChat>>>

    export type LeaveChatMutationError = ErrorType<unknown>
    export type LeaveChatMutationVariables = {params: LeaveChatParams}

    export const useLeaveChat = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof leaveChat>>, TError,LeaveChatMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof leaveChat>>,
        TError,
        LeaveChatMutationVariables,
        TContext
      > => {
      return useMutation(getLeaveChatMutationOptions(options), queryClient);
    }
